export const SUBMIT_DELAY = 1000
